import { render, staticRenderFns } from "./WaterStatement.vue?vue&type=template&id=4d612b0f&scoped=true"
import script from "./WaterStatement.vue?vue&type=script&lang=js"
export * from "./WaterStatement.vue?vue&type=script&lang=js"
import style0 from "./WaterStatement.vue?vue&type=style&index=0&id=4d612b0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d612b0f",
  null
  
)

export default component.exports